// extracted by mini-css-extract-plugin
module.exports = {"descriptionBox":"styles_descriptionBox__9fmdi"};